var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82422 23.25H10.3242C10.9455 23.25 11.4492 22.7463 11.4492 22.125V1.875C11.4492 1.25368 10.9455 0.75 10.3242 0.75H8.82422C8.2029 0.75 7.69922 1.25368 7.69922 1.875V22.125C7.69922 22.7463 8.2029 23.25 8.82422 23.25ZM20.8242 23.25H19.3242C18.7029 23.25 18.1992 22.7463 18.1992 22.125V5.625C18.1992 5.00368 18.7029 4.5 19.3242 4.5H20.8242C21.4455 4.5 21.9492 5.00368 21.9492 5.625V22.125C21.9492 22.7463 21.4455 23.25 20.8242 23.25ZM14.0742 23.25H15.5742C16.1955 23.25 16.6992 22.7463 16.6992 22.125V10.875C16.6992 10.2537 16.1955 9.75 15.5742 9.75H14.0742C13.4529 9.75 12.9492 10.2537 12.9492 10.875V22.125C12.9492 22.7463 13.4529 23.25 14.0742 23.25ZM3.57422 23.25H5.07422C5.69554 23.25 6.19922 22.7463 6.19922 22.125V15.375C6.19922 14.7537 5.69554 14.25 5.07422 14.25H3.57422C2.9529 14.25 2.44922 14.7537 2.44922 15.375V22.125C2.44922 22.7463 2.9529 23.25 3.57422 23.25Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsChart);
export default __webpack_public_path__ + "static/media/stats-chart.7c2c507703940f5845fe9a1ccd910c44.svg";
export { ForwardRef as ReactComponent };